module.exports.delay = (ms, func) -> setTimeout(func, ms)



// WEBPACK FOOTER //
// ./src/utilities.coffee